var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import History from "@irati/utils/history";
import { injectIntl } from "@irati/utils/lang";
import Receipt from "../Receipt";
var RewardSuccessPopup = /** @class */ (function (_super) {
    __extends(RewardSuccessPopup, _super);
    function RewardSuccessPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleAfterExit = function () {
            var _a = _this.props, redirectToFeed = _a.redirectToFeed, onAfterExitModal = _a.onAfterExitModal;
            if (redirectToFeed) {
                History.push("/reward", _this.context, false);
            }
            if (typeof onAfterExitModal === "function") {
                onAfterExitModal();
            }
        };
        return _this;
    }
    RewardSuccessPopup.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, rewardOrder = _a.rewardOrder;
        return (React.createElement(Receipt, { buttonText: formatMessage({ id: "reward.success.receipt.button" }), onClose: this.handleAfterExit, rewardOrder: rewardOrder }));
    };
    RewardSuccessPopup.defaultProps = {
        redirectToFeed: false,
        onAfterExitModal: null
    };
    RewardSuccessPopup.contextTypes = {
        appPath: PropTypes.string.isRequired
    };
    return RewardSuccessPopup;
}(Component));
export default injectIntl(RewardSuccessPopup);
